import React, { useEffect } from "react";
import { useLanguage } from "./LanguageContext";
import { ROUTE_MAPS } from "../translations";

export default function SEO({ pageKey }) {
  const { lang, t } = useLanguage();

  useEffect(() => {
    const metaData = t.meta[pageKey];
    if (!metaData) return;

    // Update title
    document.title = metaData.title;

    // Update description
    let descMeta = document.querySelector('meta[name="description"]');
    if (!descMeta) {
      descMeta = document.createElement("meta");
      descMeta.setAttribute("name", "description");
      document.head.appendChild(descMeta);
    }
    descMeta.setAttribute("content", metaData.description);

    // Update canonical URL
    const baseUrl = window.location.origin;
    const currentPath = ROUTE_MAPS[lang][pageKey] || "";
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute("href", `${baseUrl}${currentPath}`);

    // Update hreflang links
    const languages = ["da", "en"];
    languages.forEach((l) => {
      let hreflangLink = document.querySelector(`link[hreflang="${l}"]`);
      if (!hreflangLink) {
        hreflangLink = document.createElement("link");
        hreflangLink.setAttribute("rel", "alternate");
        hreflangLink.setAttribute("hreflang", l);
        document.head.appendChild(hreflangLink);
      }
      const path = ROUTE_MAPS[l][pageKey] || "";
      hreflangLink.setAttribute("href", `${baseUrl}${path}`);
    });

    // Update x-default hreflang (usually default language, which is Danish)
    let defaultHreflangLink = document.querySelector('link[hreflang="x-default"]');
    if (!defaultHreflangLink) {
      defaultHreflangLink = document.createElement("link");
      defaultHreflangLink.setAttribute("rel", "alternate");
      defaultHreflangLink.setAttribute("hreflang", "x-default");
      document.head.appendChild(defaultHreflangLink);
    }
    const defaultPath = ROUTE_MAPS.da[pageKey] || "";
    defaultHreflangLink.setAttribute("href", `${baseUrl}${defaultPath}`);

  }, [lang, pageKey, t]);

  return null;
}
